/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum TooltipEnum {
    INFORMATION = 'INFORMATION',
    WARNING = 'WARNING',
    ERROR = 'ERROR',
    NONE = 'NONE'
}
